// https://xpressdocs.atlassian.net/browse/PROJ-29921

module.exports = {
    "dateCreated": "2024-07-31 07:03:06",
    "dateModified": "2024-08-01 06:11:54",
    "createdBy": "Kiran Dulapally",
    "lastModifiedBy": "Kiran Dulapally",
    "idProgramType": 14,
    "idProgram": "1233",
    "idCompany": "105XPRESSDOCSDEMO742",
    "idBranch": "",
    "name": "Test Scheduled Campaign program",
    "internalNotes": "test notes",
    "active": 0,
    "useCompany": 0,
    "useBranch": 0,
    "useAgent": 0,
    "programPreferences": {
        // allowLogoGallery: false,
        allowLogoGallery: true,


        allowMailingSeals: true,
        allowAutoEnroll: true,
        // allowAutoEnroll: false,
        // allowAutoRenewal: true,
        allowAutoRenewal: false,

        customizableReturnAddress: true, // Not yet used in UI
        useImage: true,
        // allowSecondHeadshot: true,
        // allowTeamHeadshot: true,
        enableQRCode: true,
        // enableQRCode: false,

        allowCustomUrl: false,
        allowHomeValue: false,
        allowXpresslinks: false,

        "subCategoryName": "APM Social Media Tests",
        "subCategoryIDs": ["130391"],
        "subCategoryID": "130391", // Deprecated
        "billingAccountName": "100% TEST BILLING",
        "idBillingAccount": "acc20091119500", // do we want these options?
        "linkName": "test link",
        "linkActive": 1,
        "displayProductSidebar": 0,
        // "useCopay": 1, // do we want these options?
        "useVoucher": 1, // do we want these options?
        "useBillingAccount": 0, // do we want these options?
        "displayProductGeneral": 0,
        "autoNewUserSubscribe": 0,
        "includeOrResident": 0,
        // "imageName": "Default Image XXX",
        "imageName": "Default Img",
        // requireCreditCard: true,
        requireCreditCard: false,


        // landingPageContent: "<p><strong><span style=\"font-size:18px\">This is headline</span></strong><br /><span style=\"color:#FF0000\">This is tagline in Red color</span></p>" + "<ul class=\"icon-S\">\t<li>ScheduleAhead Icon</li><li>ScheduleAhead Icon</li></ul><ul class=\"icon-B\">\t<li>ScheduleAhead Icon</li><li>ScheduleAhead Icon</li></ul>",

        "bannerImageMobile": "https://assets.awsdev.xpressdocs.com/next_images/company/21windermerec/3096e2d4/banner_mobile.mp4",
        "bannerImageDesktop": "https://assets.awsdev.xpressdocs.com/next_images/company/21windermerec/3096e2d4/banner_desktop.jpg",
        "landingPageContent": "<h3><strong>This is headline</strong></h3>\r\n\r\n<ul class=\"icon-S\">\r\n\t<li>ScheduleAhead content</li>\r\n</ul>\r\n<ul class=\"icon-C\">\r\n\t<li>ConsistentCommitment content</li>\r\n</ul>\r\n<ul class=\"icon-B\">\r\n\t<li>Budgetfriendly content</li>\r\n</ul>\r\n<ul class=\"icon-F\">\r\n\t<li>FindNewLeads content</li>\r\n</ul>\r\n\r\n",
        "productImageDesktop": "https://assets.awsdev.xpressdocs.com/next_images/company/21windermerec/3096e2d4/product_desktop.mp4",

        // heroImageDesktop:"https://assets.awsdev.xpressdocs.com/next_images/company/21windermerec/9b88ccd3/hero_desktop.jpg",
        // heroImageMobile:"https://assets.awsdev.xpressdocs.com/next_images/company/21windermerec/9b88ccd3/hero_mobile.png",

        // "heroImage": "https://assets.awsdev.xpressdocs.com/next_images/company/21windermerec/hero.png",
        // "heroImage": require("./aaa.png"),
        // "heroImage": "https://assets.awsdev.xpressdocs.com/next_images/company/d2dbadb1/hero.jpg",


        // "taglineText": "Effortlessly engage your clients with prescheduled direct mail campaigns for the entire year.",
        "feature1Text": "Enroll in future campaign deliveries months in advance with ease.",
        "feature2Text": "Mail or ship each edition confidently with XD's reliable distribution.",
        "feature3Text": "Reach the right clientele with our targeted regional and demographic lists.",
        "feature4Text": "Enroll now, pay later for easier budget planning; payment is due at campaign production.\r\n",
        // "headlineText": "Scheduled Campaigns",
        "taglineColor": "#ffffff",
        "feature1Color": "#002e56",
        "feature2Color": "#002e56",
        "feature3Color": "#002e56",
        "feature4Color": "#002e56",
        "headlineColor": "#ec008c",
        // "subCategoryID": "218350",
        // "subCategoryName": "Scheduled Campaigns",
        "taglineFontSize": "26",
        "feature1FontSize": "20",
        "feature2FontSize": "20",
        "feature3FontSize": "20",
        "feature4FontSize": "20",
        "headlineFontSize": "65",
        // "idBillingAccount": "",
        "taglineAlignment": "center",
        "headlineAlignment": "center",

        series: [
            {
                id: "2024",
                name: "2024",
            },
            {
                id: "2025",
                name: "2025",
                // forceAutoEnroll: true,
            },
        ],


        editions: [
            {
                "name": "Septober",
                "seriesId": "2024",
                "comment": "update comment",
                "editionId": "e1",
                // "templateId": "334163",
                "templateId": "334164",
                "enrollmentDeadline": "2024-09-06",
                "orderReviewDeadline": "2024-09-12"
            },
            {
                "name": "Oktober",
                "seriesId": "2025",
                "comment": "Willkommen auf dem Oktoberfest",
                "editionId": "e2",
                "templateId": "334164",
                "enrollmentDeadline": "2025-10-06",
                "orderReviewDeadline": "2025-12-12"
            },
            {
                "name": "T-day",
                "seriesId": "2025",
                "comment": "Thanksgiving",
                "editionId": "e3",
                "templateId": "334165",
                "enrollmentDeadline": "2025-11-06",
                "orderReviewDeadline": "2025-11-12"
            },
            {
                "name": "Christmas",
                "seriesId": "2025",
                description: "Aaaa aaaa Aaaa aaaa Aaaa aaaa aaaa Aaaa aaaa Aaaa aaaa aaaa Aaaa aaaa Aaaa aaaa aaaa Aaaa aaaa Aaaa aaaa",
                "comment": "Happy Winter Solstice",
                "editionId": "e4",
                "templateId": "334166",
                "enrollmentDeadline": "2025-12-06",
                "orderReviewDeadline": "2025-12-12"
            }
        ],
    },

};
